export default {
  nav: {
    nosotros: "Nosotros",
    talentos: "Talentos",
    trabajo: "Nuestro Trabajo",
    cta: "Trabajemos juntos",
  },
  hero: {
    line1: "Creadores",
    line2: "que mueven",
    line3: "audiencias.",
    ctaPrimary: "Trabajemos juntos",
    ctaSecondary: "Ver talentos",
    scroll: "Scroll",
  },
  nosotros: {
    tag: "Quiénes somos",
    title1: "La agencia que",
    title2: "entiende",
    title3: "a los creadores.",
    body: "En 301+, no solo representamos talento; curamos carreras. Creemos en el poder de las historias bien contadas y en la conexión real entre creadores y marcas que definen la cultura. Nuestro escenario no es internet, es el impacto duradero.",
    brandsLabel: "Marcas que confían en nuestro talento",
    stats: [
      { value: "150+", label: "Campañas ejecutadas", desc: "Desde lanzamientos hasta campañas 360°" },
      { value: "20M+", label: "En valor de ALCANCES", desc: "Generados para marcas aliadas" },
      { value: "89%", label: "Satisfacción de marcas", desc: "Clientes que repiten con nosotros" },
    ],
  },
  talentos: {
    tag: "Roster exclusivo",
    title1: "Nuestros",
    title2: "Talentos",
    followers: "Seguidores totales",
    engagement: "Engagement",
    socials: "Redes sociales",
  },
  enfoques: {
    label: "Nuestro trabajo",
    categories: [
      {
        tag: "Campañas",
        subtitle: "De la idea al impacto",
        title: "Campañas que generan conversación",
        desc: "Diseñamos campañas de principio a fin con el talento ideal para cada marca.",
        highlights: ["Estrategia creativa", "Selección de talento", "Producción", "Reportes de impacto"],
        stat1Label: "ROI promedio",
        stat2Label: "Campañas exitosas",
      },
      {
        tag: "Eventos",
        subtitle: "Experiencias que trascienden",
        title: "Eventos que se vuelven contenido",
        desc: "Convertimos cada evento en contenido que amplifica tu marca más allá del día.",
        highlights: ["Activaciones en vivo", "Lanzamientos", "Press trips", "Brand experiences"],
        stat1Label: "Asistentes promedio",
        stat2Label: "Eventos anuales",
      },
      {
        tag: "Entrevistas",
        subtitle: "Voces que tienen confianza",
        title: "Entrevistas que posicionan",
        desc: "Voces auténticas que posicionan tu marca como referente en su industria.",
        highlights: ["Podcasts", "Entrevistas en video", "Conversaciones de marca", "Thought leadership"],
        stat1Label: "Alcance promedio",
        stat2Label: "Horas de contenido",
      },
      {
        tag: "Embajadores",
        subtitle: "Relaciones que construyen marcas",
        title: "Embajadores a largo plazo",
        desc: "Relaciones duraderas que dan credibilidad y consistencia a tu marca.",
        highlights: ["Programas de embajadores", "Contratos anuales", "Desarrollo de marca personal", "Exclusividad"],
        stat1Label: "Retención promedio",
        stat2Label: "Relaciones activas",
      },
    ],
  },
  contacto: {
    tag: "Hablemos",
    title1: "let's work",
    title2: "together",
    copy: "copiar mail",
    copied: "copiado",
  },
  footer: {
    brand: "301+ Management Agency",
    rights: "Todos los derechos reservados.",
  },
};